import {put, select} from 'redux-saga/effects';
import {AppState} from '../../../../../../state/store';
import {setCurrentPage, setIsViewerEnd} from '../state/textViewerSlice';

export function* checkIsViewerEnd({productId}: {productId: number}) {
  const {currentChapterId, chapterCount} = yield select((state: AppState) => ({
    currentChapterId: state.textViewer.viewData[productId]?.currentChapterId,
    chapterCount: state.textViewer.viewData[productId]?.chapterCount,
  }));

  if (currentChapterId === undefined || !chapterCount) {
    return;
  }
  // 현재 챕터가 총 챕터 수보다 크거나 같다면 뷰어엔드로 이동시킵니다.
  if (currentChapterId >= chapterCount) {
    yield put(setCurrentPage({productId, page: 1}));
    yield put(
      setIsViewerEnd({
        productId,
        isViewerEnd: true,
      })
    );
  } else {
    yield put(
      setIsViewerEnd({
        productId,
        isViewerEnd: false,
      })
    );
  }
}
